import { fromSqlDateTime } from "helpers/Date";
import React, { useContext } from "react";
import { ContentContext } from "context/Content";

function StaticDateField(props) {
    const { state } = useContext(ContentContext);

    if (state.loading || state.performingStateChange || !state.content) {
        return (
            <div>
                <span className="-mb-1 block text-sm font-medium text-gray-700">
                    {props.label}
                </span>
                <span className="animate-pulse rounded bg-gray-300 text-sm text-gray-300">
                    00/00/0000 00:00:00
                </span>
            </div>
        );
    }

    return (
        <div>
            <span className="-mb-1 block text-sm font-medium text-gray-700">
                {props.label}
            </span>
            <span className="text-sm">
                {state.content[props.field]
                    ? fromSqlDateTime(state.content[props.field]).toFormat("ff")
                    : props.defaultValue}
            </span>
        </div>
    );
}

export default StaticDateField;
